import React from "react";
import { Check, Circle, MinusCircle } from "lucide-react";

const STATES = [
  { key: "open",         icon: Circle,       label: "Offen",            ring: "border-slate-300 text-slate-400", bg: "" },
  { key: "done",         icon: Check,        label: "Erledigt",         ring: "border-emerald-500 text-white bg-emerald-500", bg: "bg-emerald-50" },
  { key: "not_relevant", icon: MinusCircle,  label: "Nicht relevant",   ring: "border-slate-300 text-slate-400 bg-slate-100", bg: "bg-slate-50/60" },
];

/**
 * 3-Zustand Toggle (offen → erledigt → nicht relevant → offen).
 */
export default function SubitemRow({ subitem, onChange, disabled }) {
  const current = STATES.find((s) => s.key === subitem.status) || STATES[0];
  const Icon = current.icon;
  const next = () => {
    if (disabled) return;
    const order = ["open", "done", "not_relevant"];
    const idx = order.indexOf(subitem.status);
    const nextStatus = order[(idx + 1) % order.length];
    onChange(nextStatus);
  };
  const isDone = subitem.status === "done";
  const isSkip = subitem.status === "not_relevant";

  return (
    <button
      type="button"
      onClick={next}
      disabled={disabled}
      data-testid={`subitem-${subitem.id}`}
      data-status={subitem.status}
      title={`${current.label}${subitem.is_critical ? " · wichtig für den Notfall" : ""}`}
      className={`group w-full flex items-center gap-3 px-4 py-3 rounded-xl border text-left text-sm transition-all
        ${current.bg}
        ${isDone ? "border-emerald-200" : "border-slate-100 hover:border-slate-300"}
        ${disabled ? "opacity-60 cursor-not-allowed" : "hover:shadow-[0_2px_8px_rgba(15,23,42,0.04)]"}
      `}
    >
      <span className={`h-5 w-5 rounded-full border flex items-center justify-center transition-all ${current.ring}`}>
        <Icon className="h-3 w-3" strokeWidth={2.5} />
      </span>
      <span className={`flex-1 ${isDone ? "text-slate-500 line-through decoration-emerald-400/60" : isSkip ? "text-slate-400 italic" : "text-slate-700"}`}>
        {subitem.label}
      </span>
      {subitem.is_critical && !isSkip && (
        <span className="text-[10px] uppercase tracking-wider text-amber-600">Notfall</span>
      )}
    </button>
  );
}
